import { CardActionArea, CircularProgress, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

import { spacings } from '../../../../../theme';
import { InlineModal } from './InlineModal';

type Props =
  | {
      mode: 'view';
      onClick: (() => void) | null;
      children: React.ReactNode;
      label?: string;
    }
  | {
      mode: 'edit';
      saving?: boolean;
      onClickAway: () => void | null;
      children: React.ReactNode;
      label?: string;
    };

export const TaskField = (props: Props): React.ReactElement => {
  switch (props.mode) {
    case 'view':
      return <TaskFieldView {...props} />;
    case 'edit':
      return <TaskFieldEdit {...props} />;
  }
};

export const TaskFieldView = ({
  onClick,
  label,
  children,
}: Omit<Props & { mode: 'view' }, 'mode'>): React.ReactElement => {
  const classes = useStyles();

  return (
    <>
      <CardActionArea
        disabled={onClick == null}
        classes={{ root: classes.cardActionAreaRoot }}
        onClick={onClick != null ? onClick : undefined}
      >
        <div className={classes.innerRoot}>
          {label != null && <span className={classes.label}>{label}:</span>}
          {children}
        </div>
      </CardActionArea>
    </>
  );
};

export const TaskFieldEdit = ({
  onClickAway,
  label,
  children,
  saving,
}: Omit<Props & { mode: 'edit' }, 'mode'>): React.ReactElement => {
  const classes = useStyles();

  return (
    <InlineModal onClose={onClickAway}>
      <div className={classes.innerRoot}>
        {label != null && <span className={classes.label}>{label}:</span>}
        {children}
        {saving && <CircularProgress className={classes.loader} color="inherit" size={20} />}
      </div>
    </InlineModal>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    cardActionAreaRoot: {
      marginLeft: `-${spacings.small}px`,
      padding: spacings.small,
      // Clear 100% width from CardActionArea
      width: 'unset',
      borderRadius: spacings.small,
    },
    innerRoot: {
      width: '100%',
      minHeight: 28,
      display: 'inline-flex',
      alignItems: 'center',

      fontSize: 15,
      fontFamily: 'Inter',
      letterSpacing: 'normal',

      '&:focus': {
        // Hide default focus outline across the modal boundries
        outline: '0px',
      },
    },
    label: {
      marginRight: spacings.small,
    },
    loader: {
      marginLeft: spacings.small,
    },
  })
);
